
namespace advisorop.components.servicer {
    
    class AdvisorCrudController {

        $router;
        public model: domains.IAdvisor;
        isWorking = false;

        advisorId: number;
        static $inject = [];
        constructor() {
            this.model = new domains.Advisor();
            this.model.useEmailAsUsername = true;
        }

        onAdvisorLoaded(data: any) {
            this.model = data;
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            if (next.params.advisorId) {
                this.advisorId = next.params.advisorId;
            }
        }
    }


    class AdvisorCrud implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisorCrudController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/advisor-crud.html';            
        }

    }
    angular.module(Constants.APP).component("advisorCrud", new AdvisorCrud());
}